import { IGetSearch } from 'apis/type';
import { formatToRequestParameter } from 'utils/formatting';
import apiGateway from '../../PatientList/api/apiGateway';
import {
  IGetDisease,
  IGetFee,
  IGetFees,
  IGetMedication,
  IGetMedications,
  IGetNanda,
  IPostUploadFile,
} from './type';

export const getDisease = (request: IGetDisease) => {
  const { keyword } = request;

  const baseUrl = () => {
    if (keyword) return '/admin/disease/search';
    return '/admin/disease';
  };

  const url = `${baseUrl()}?size=20&${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const getFees = (request: IGetFees) => {
  const { keyword } = request;

  const baseUrl = () => {
    if (keyword) return '/admin/fee/search';
    return '/admin/fee';
  };

  const url = `${baseUrl()}?size=20&${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

// 가상환자 생성때 쓰는 수가코드
export const getFee = ({ feeId }: IGetFee) => {
  const url = `/admin/fee/${feeId}`;
  return apiGateway.get(url);
};

export const getMedications = (request: IGetMedications) => {
  const { keyword } = request;

  const baseUrl = () => {
    if (keyword) return '/admin/medication/search';
    return '/admin/medication';
  };

  const url = `${baseUrl()}?size=20&${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

// 가상환자 생성때 쓰는 성분명 코드
export const getMedication = ({ medicationId }: IGetMedication) => {
  const url = `/admin/medication/${medicationId}`;
  return apiGateway.get(url);
};

export const getNandas = (request: IGetNanda) => {
  const { keyword } = request;

  const baseUrl = () => {
    if (keyword) return '/admin/nanda/search';
    return '/admin/nanda';
  };

  const url = `${baseUrl()}?size=20&${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const postUploadFile = (request: IPostUploadFile) => {
  const url = `/file/upload`;
  const { file } = request;
  const formData = new FormData();
  formData.append('file', file, file.name);
  return apiGateway.post(url, formData);
};

export const postAdminClearKey = () => {
  const url = '/admin/clearKey';
  return apiGateway.post(url, {});
};

export const getDiseaseSearch = (request: IGetSearch) => {
  const url = `/main/disease/search?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};
